export default __webpack_public_path__ + "static/snake-de42b0b10f5b8b85b826bdeab36f3c78.gif";